const DEFAULT_LOCALE = ['en-US'];
function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}
const isValidDateString = dateStr => {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  return date.toString() !== 'Invalid Date';
};
const getValidLocale = preferredLocale => {
  const locale = preferredLocale !== null && preferredLocale !== void 0 && preferredLocale.length ? preferredLocale : DEFAULT_LOCALE;
  const supportedLocales = Intl.DateTimeFormat.supportedLocalesOf(locale);
  return supportedLocales.length ? supportedLocales : DEFAULT_LOCALE;
};
const createDateFormatter = locale => {
  return new Intl.DateTimeFormat(locale, {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};
const formatEnglishDate = (date, formatter) => {
  const day = date.getDate();
  const suffix = getOrdinalSuffix(day);
  const parts = formatter.formatToParts(date);
  const formattedParts = parts.map(part => part.type === 'day' ? `${part.value}${suffix}` : part.value);
  return formattedParts.join('');
};
function formatLocalizedDate(dateStr, preferredLocale) {
  var _validLocale$;
  if (!isValidDateString(dateStr)) {
    return 'Invalid Date';
  }
  const date = new Date(dateStr);
  const validLocale = getValidLocale(preferredLocale);
  const formatter = createDateFormatter(validLocale);
  return (_validLocale$ = validLocale[0]) !== null && _validLocale$ !== void 0 && _validLocale$.startsWith('en') ? formatEnglishDate(date, formatter) : formatter.format(date);
}

export { formatLocalizedDate, getOrdinalSuffix };
